import { Component, Vue } from 'vue-property-decorator';

import AppointmentModal from '@/components/appointment';
import NoRoomsModal from '@/components/no-rooms';
import RemoveAppointmentModal from '@/components/remove-appointment';
import AddSeatModal from '@/components/add-seat';
import AddRoomModal from '@/components/add-room';
import RemoveUserModal from '@/components/remove-user';
import AddUserModal from '@/components/add-user';
import OverridePremiumModal from '@/components/override-admin';
import CancelSubscriptionModal from '@/components/cancel-subscription';
import ChangeSubscriptionModal from '@/components/change-subscription';
import DeleteCompanyModal from '@/components/delete-company';
import { ModalState } from '@/definitions';
import { Action } from '@/store';

import template from './modal.vue';

@Component({
  mixins: [template],
  components: {
    AppointmentModal,
    NoRoomsModal,
    RemoveAppointmentModal,
    AddSeatModal,
    AddRoomModal,
    RemoveUserModal,
    AddUserModal,
    OverridePremiumModal,
    CancelSubscriptionModal,
    ChangeSubscriptionModal,
    DeleteCompanyModal
  }
})
export default class Modal extends Vue {
  get modal(): ModalState {
    return this.$Store.state.modal;
  }

  closeModal(): void {
    this.$Store.dispatch(Action.HIDE_MODAL);
  }
}